import type { MomentExtension } from '@ricoh/ria.client.core/plugins/moment/extensions';
import type { Func } from '@ricoh/ria.client.core/types/core/function.type';

import { extendCreators, extendFunctions, overrideFunctions } from '@ricoh/ria.client.core/plugins/moment/extensions';
import setupDurationFormat from 'moment-duration-format';
import { tz } from 'moment-timezone/moment-timezone-utils';
import moment from 'moment/min/moment-with-locales';

import datetimeConfig from './_config';

moment.fn = Object.assign(moment.fn, overrideFunctions, extendFunctions);

/** Moment with extension functions. */
const DateTime: MomentExtension = Object.assign<MomentExtension>(moment, extendCreators, {
  tz,
  config: datetimeConfig,
});

(setupDurationFormat as unknown as Func<[moment: MomentExtension]>)(DateTime);

export default DateTime;
